import DateFnsUtils from "@date-io/date-fns";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { API } from "aws-amplify";
import esLocale from "date-fns/locale/es";
import React, { useContext, useReducer, useState } from "react";
import NumberFormat from "react-number-format";
import {
  formatRut,
  nombreEsValido,
  rutEsValido,
  toTitleCase,
  unformatRut,
  validateEmail
} from "../../../functions";
import { AppContext } from "../../App";
import { DesktopContext } from "../../../views/Desktop";
import { MobileContext } from "../../../views/Mobile";
import AppBarCreate from "../../common/AppBarCreate";

const useStyles = makeStyles(theme => ({
  container: {
    paddingTop: theme.spacing(2, 0)
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "& > *": {
      margin: theme.spacing(1),
      width: "100%"
    }
  },
  button: {
    margin: theme.spacing(2, 0)
  }
}));

const initialState = {
  nombreBeneficiario: "",
  telefonoBeneficiario: "",
  correoBeneficiario: "",
  rutAsegurado: "",
  nombreAsegurado: "",
  descripcion: "",
  ubicacion: "",
  certificado: "si",
  fecha: new Date(),
  error: {
    nombreBeneficiario: false,
    telefonoBeneficiario: false,
    correoBeneficiario: false,
    rutAsegurado: false,
    nombreAsegurado: false,
    descripcion: false,
    ubicacion: false,
    certificado: false,
    fecha: false
  }
};

const reducer = (state, { type, payload }) => {
  switch (type) {
    case "nombreBeneficiario":
      return {
        ...state,
        [type]: payload,
        error: { ...state.error, nombreBeneficiario: !nombreEsValido(payload) }
      };
    case "telefonoBeneficiario":
      return {
        ...state,
        [type]: payload,
        error: {
          ...state.error,
          telefonoBeneficiario: !payload || payload === "" || payload.length < 8
        }
      };
    case "correoBeneficiario":
      return {
        ...state,
        [type]: payload,
        error: { ...state.error, correoBeneficiario: !validateEmail(payload) }
      };
    case "rutAsegurado":
      return {
        ...state,
        [type]: payload,
        error: { ...state.error, rutAsegurado: !rutEsValido(payload) }
      };
    case "nombreAsegurado":
      return {
        ...state,
        [type]: payload,
        error: { ...state.error, nombreAsegurado: !nombreEsValido(payload) }
      };
    case "descripcion":
      return {
        ...state,
        [type]: payload,
        error: { ...state.error, descripcion: !payload || payload === "" }
      };
    case "ubicacion":
      return {
        ...state,
        [type]: payload,
        error: { ...state.error, ubicacion: !payload || payload === "" }
      };
    case "certificado":
      return {
        ...state,
        [type]: payload,
        error: { ...state.error, certificado: !payload || payload === "" }
      };
    case "fecha":
      return {
        ...state,
        [type]: payload,
        error: { ...state.error, fecha: !payload || payload === "" }
      };
    case "error":
      return {
        ...state,
        error: { ...state.error, [payload]: true }
      };
    default:
      return { ...initialState };
  }
};

const TicketCreate = ({ mobile, account, onBack, onClose }) => {
  const classes = useStyles();
  const { user } = useContext(AppContext);
  const { onTicketCreated } = useContext(DesktopContext);
  const { onTicketCreatedMobile } = useContext(MobileContext);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [fetchingData, setFetchingData] = useState(false);
  const [datos, dispatch] = useReducer(reducer, initialState);
  const [noEmail, setNoEmail] = useState(false);

  const validate = () => {
    if (!nombreEsValido(datos.nombreBeneficiario))
      dispatch({ type: "error", payload: "nombreBeneficiario" });

    if (
      !datos.telefonoBeneficiario ||
      datos.telefonoBeneficiario === "" ||
      datos.telefonoBeneficiario.length < 8
    )
      dispatch({ type: "error", payload: "telefonoBeneficiario" });

    if (!noEmail && !validateEmail(datos.correoBeneficiario))
      dispatch({ type: "error", payload: "correoBeneficiario" });

    if (!rutEsValido(datos.rutAsegurado)) dispatch({ type: "error", payload: "rutAsegurado" });

    if (!nombreEsValido(datos.nombreAsegurado))
      dispatch({ type: "error", payload: "nombreAsegurado" });

    if (!datos.descripcion || datos.descripcion === "")
      dispatch({ type: "error", payload: "descripcion" });

    if (!datos.fecha || datos.fecha === "") dispatch({ type: "error", payload: "fecha" });

    if (!datos.ubicacion || datos.ubicacion === "")
      dispatch({ type: "error", payload: "ubicacion" });

    return (
      nombreEsValido(datos.nombreBeneficiario) &&
      datos.telefonoBeneficiario &&
      datos.telefonoBeneficiario.length >= 8 &&
      rutEsValido(datos.rutAsegurado) &&
      nombreEsValido(datos.nombreAsegurado) &&
      datos.descripcion &&
      datos.descripcion !== "" &&
      datos.fecha &&
      datos.fecha !== "" &&
      datos.ubicacion &&
      datos.ubicacion !== ""
    );
  };

  const create = async () => {
    setFetchingData(true);

    if (validate()) {
      try {
        const init = {
          body: {
            id_usuario_crea: user.id_usuario,
            nombreBeneficiario: datos.nombreBeneficiario,
            telefonoBeneficiario: datos.telefonoBeneficiario,
            correoBeneficiario: datos.correoBeneficiario,
            rutAsegurado: datos.rutAsegurado,
            nombreAsegurado: datos.nombreAsegurado,
            descripcion: datos.descripcion,
            fecha: datos.fecha,
            ubicacion: datos.ubicacion,
            certificado: datos.certificado
          }
        };

        const result = await API.post(
          process.env.REACT_APP_TICKETS_API,
          "/tickets/banigualdad",
          init
        );

        if (result.success) {
          if (mobile) {
            onTicketCreatedMobile();
          } else {
            onTicketCreated();
          }
          onClose();
        }
      } catch (err) {
        console.error("ticketCreate.create", err);
      }
    }

    setFetchingData(false);
  };

  const searchContact = async () => {
    setFetchingData(true);

    if (datos.rutAsegurado && rutEsValido(datos.rutAsegurado)) {
      try {
        const init = {
          queryStringParameters: {
            rut: datos.rutAsegurado,
            tipo: "asegurado",
            cuenta: account.id_cuenta
          }
        };
        const result = await API.get(process.env.REACT_APP_HUB_API, "/contactos", init);

        if (result.success) {
          if (result.data.length === 0) {
            setMessage("Asegurado no encontrado");
            dispatch({
              type: "nombreAsegurado",
              payload: ""
            });
          } else {
            setMessage("Asegurado encontrado");
            dispatch({
              type: "nombreAsegurado",
              payload: result.data.nombre_contacto
            });
          }
          setOpen(true);
        }
      } catch (err) {
        console.error("fetchContactos", err);
      }
    }

    setFetchingData(false);
  };

  const alert = () => {
    return (
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message={message}
        action={
          <React.Fragment>
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
    );
  };

  const handleClose = (event, reason) => {
    setOpen(false);
  };

  const renderForm = () => {
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
        {alert()}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" component="p">
              Datos del contacto
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              disabled={fetchingData}
              label="Nombre del contacto"
              InputLabelProps={{
                shrink: true
              }}
              value={datos.nombreBeneficiario && toTitleCase(datos.nombreBeneficiario)}
              onChange={({ target }) =>
                dispatch({
                  type: "nombreBeneficiario",
                  payload: target.value
                })
              }
              onBlur={() =>
                dispatch({ type: "nombreBeneficiario", payload: datos.nombreBeneficiario })
              }
              error={datos.error.nombreBeneficiario}
              helperText={datos.error.nombreBeneficiario && "Debe ingresar un nombre"}
            />
          </Grid>
          <Grid item xs={12}>
            <NumberFormat
              id="phone"
              customInput={TextField}
              format="+56 9 #### ####"
              allowEmptyFormatting
              size="small"
              variant="outlined"
              fullWidth
              type="tel"
              label="Teléfono celular *"
              placeholder="Ej: +56 9 1234 5678"
              InputLabelProps={{
                shrink: true
              }}
              value={datos.telefonoBeneficiario}
              disabled={fetchingData}
              onValueChange={({ value }) =>
                dispatch({ type: "telefonoBeneficiario", payload: value })
              }
              onBlur={() =>
                dispatch({ type: "telefonoBeneficiario", payload: datos.telefonoBeneficiario })
              }
              error={datos.error.telefonoBeneficiario}
              helperText={datos.error.telefonoBeneficiario && "Debe ingresar un celular valido"}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              disabled={fetchingData || noEmail}
              label="Correo"
              InputLabelProps={{
                shrink: true
              }}
              value={datos.correoBeneficiario}
              onChange={({ target }) =>
                dispatch({
                  type: "correoBeneficiario",
                  payload: target.value
                })
              }
              onBlur={() =>
                dispatch({ type: "correoBeneficiario", payload: datos.correoBeneficiario })
              }
              error={datos.error.correoBeneficiario}
              helperText={datos.error.correoBeneficiario && "Debe ingresar un correo valido"}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={noEmail}
                  onChange={() => setNoEmail(!noEmail)}
                  name="noEmail"
                  color="primary"
                />
              }
              label="No tiene"
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6" component="p">
              Datos del asegurado
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <TextField
              id="rut"
              size="small"
              variant="outlined"
              fullWidth
              label="Rut *"
              placeholder="Ej: 12.345.678-9"
              InputLabelProps={{
                shrink: true
              }}
              value={datos.rutAsegurado && formatRut(datos.rutAsegurado)}
              disabled={fetchingData}
              onChange={({ target }) => {
                dispatch({ type: "rutAsegurado", payload: unformatRut(target.value) });
              }}
              onBlur={() => {
                searchContact();
                dispatch({ type: "rutAsegurado", payload: datos.rutAsegurado });
              }}
              error={datos.error.rutAsegurado}
              helperText={datos.error.rutAsegurado && "Debe ingresar un Rut valido"}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              disabled={fetchingData}
              label="Nombre"
              InputLabelProps={{
                shrink: true
              }}
              value={datos.nombreAsegurado && toTitleCase(datos.nombreAsegurado)}
              onChange={({ target }) =>
                dispatch({
                  type: "nombreAsegurado",
                  payload: target.value
                })
              }
              onBlur={() => dispatch({ type: "nombreAsegurado", payload: datos.nombreAsegurado })}
              error={datos.error.nombreAsegurado}
              helperText={datos.error.nombreAsegurado && "Debe ingresar un nombre"}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              size="small"
              variant="outlined"
              disabled={fetchingData}
              label="Descripción del siniestro"
              InputLabelProps={{
                shrink: true
              }}
              value={datos.descripcion}
              onChange={({ target }) =>
                dispatch({
                  type: "descripcion",
                  payload: target.value
                })
              }
              onBlur={() => dispatch({ type: "descripcion", payload: datos.descripcion })}
              error={datos.error.descripcion}
              helperText={datos.error.descripcion && "Debe ingresar una descripción"}
            />
          </Grid>
          <Grid item xs={12}>
            <KeyboardDatePicker
              fullWidth
              disabled={fetchingData}
              disableToolbar
              disableFuture
              size="small"
              variant="inline"
              inputVariant="outlined"
              format="dd/MM/yyyy"
              id="date-picker-inline"
              label="Fecha del siniestro"
              value={datos.fecha}
              onChange={date =>
                dispatch({
                  type: "fecha",
                  payload: date
                })
              }
              onBlur={() => dispatch({ type: "fecha", payload: datos.fecha })}
              error={datos.error.fecha}
              helperText={datos.error.fecha && "Debe ingresar una fecha"}
              KeyboardButtonProps={{
                "aria-label": "change date"
              }}
              InputLabelProps={{
                shrink: true
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              disabled={fetchingData}
              label="Ubicación actual"
              InputLabelProps={{
                shrink: true
              }}
              value={datos.ubicacion}
              onChange={({ target }) =>
                dispatch({
                  type: "ubicacion",
                  payload: target.value
                })
              }
              onBlur={() => dispatch({ type: "ubicacion", payload: datos.ubicacion })}
              error={datos.error.ubicacion}
              helperText={datos.error.ubicacion && "Debe ingresar una ubicacion"}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" component="p">
              ¿Posee certificado de defunción?
            </Typography>
            <RadioGroup
              value={datos.certificado}
              onChange={({ target }) =>
                dispatch({
                  type: "certificado",
                  payload: target.value
                })
              }
            >
              <FormControlLabel
                disabled={fetchingData}
                className="mb-0"
                value={"si"}
                control={<Radio />}
                label="Si"
              />
              <FormControlLabel
                disabled={fetchingData}
                value={"no"}
                control={<Radio />}
                label="No"
              />
            </RadioGroup>
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    );
  };

  return (
    <>
      <AppBarCreate title="Crear Caso" onBack={onClose} onClose={onClose} />
      <Container className={classes.container} maxWidth="sm">
        {renderForm()}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              className={classes.button}
              variant="contained"
              color="secondary"
              fullWidth
              disabled={fetchingData}
              onClick={create}
            >
              Guardar
            </Button>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default TicketCreate;
